// Product integrations, how CoVerify connects with the rest of CoSec Global.
// Mirrors the "Bright Product Integrations" pattern from BrightChecks.
import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Building2, FileSpreadsheet, ShieldCheck, Link2 } from "lucide-react";

const INTEGRATIONS = [
  {
    key: "cosecapp",
    icon: Building2,
    title: "CoSec App ↔ CoVerify",
    body:
      "CoVerify integrates with CoSec App to support ECCTA compliance by linking identity verification directly to company secretarial workflows. Identity checks can be completed as part of appointment, PSC and director management processes, with verified personal codes stored securely against the right entity record.",
    href: "/cosecapp",
    hrefLabel: "Explore CoSec App",
  },
  {
    key: "coform",
    icon: FileSpreadsheet,
    title: "CoForm ↔ CoVerify",
    body:
      "CoVerify integrates with CoForm to reduce manual data entry during incorporation. Client details such as names and email addresses can be pulled through automatically, identity checks initiated directly from CoForm, and verification personal codes stored against the new entity ready for Companies House submission.",
    href: "/coform",
    hrefLabel: "Explore CoForm",
  },
];

export default function Integrations() {
  return (
    <section id="integrations" className="py-20 md:py-28">
      <div className="container-cv">
        <div className="max-w-3xl">
          <span className="section-eyebrow">CoSec Global integrations</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.08]">
            Connected to the rest of{" "}
            <span className="text-accent">CoSec Global.</span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-muted-foreground">
            CoVerify integrates with selected CoSec Global products to help UK practices manage identity verification as part of wider compliance and entity workflows.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {INTEGRATIONS.map((it) => (
            <article
              key={it.key}
              data-testid={`coverify-integration-${it.key}`}
              className="relative rounded-2xl border border-border bg-white p-6 md:p-8 hover:-translate-y-1 hover:border-accent/60 hover:shadow-[0_18px_48px_-18px_rgba(14,58,95,0.18)] transition-all"
            >
              <div className="flex items-center gap-3">
                <div className="h-11 w-11 grid place-items-center rounded-xl bg-primary/10 text-primary">
                  <it.icon className="h-5 w-5" />
                </div>
                <Link2 className="h-4 w-4 text-accent" />
                <div className="h-11 w-11 grid place-items-center rounded-xl bg-accent/15 text-primary">
                  <ShieldCheck className="h-5 w-5" />
                </div>
              </div>
              <h3 className="mt-5 font-display text-xl md:text-2xl font-bold text-primary tracking-tight">{it.title}</h3>
              <p className="mt-3 text-sm md:text-base text-muted-foreground leading-relaxed">{it.body}</p>
              <Link
                to={it.href}
                data-testid={`coverify-integration-cta-${it.key}`}
                className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-primary hover:text-accent transition-colors"
              >
                {it.hrefLabel} <ArrowUpRight className="h-4 w-4" />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
